import PropTypes from "prop-types";

import ReadAloudSpans from "@/view/ReadAloudControls/ReadAloudSpans";
import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import getLanguageCode from "@/view/utils/getLanguageCode";
import { titleCss } from "./ContentDisplayTitle.style";

const propTypes = {
  title: PropTypes.node,
  currentLevel: PropTypes.object,
};

const ContentDisplayTitle = ({ title, currentLevel }) => {
  const { isReadAloudModeActive, readAloudSpanRefs } = useReadAloudMode();

  return (
    <h1
      lang={getLanguageCode(currentLevel?.language)}
      css={titleCss}
      ref={(ref) => {
        if (ref) {
          readAloudSpanRefs.current.title = ref;
        }
      }}
    >
      {isReadAloudModeActive ? (
        <ReadAloudSpans text={title} startOffsetRelativeToParent={0} />
      ) : (
        title
      )}
    </h1>
  );
};

const Unauth = ({ title, currentLevel }) => {
  return (
    <h1 lang={getLanguageCode(currentLevel?.language)} css={titleCss}>
      {title}
    </h1>
  );
};

ContentDisplayTitle.propTypes = propTypes;
Unauth.propTypes = propTypes;

ContentDisplayTitle.Unauth = Unauth;

export default ContentDisplayTitle;
